module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAALElEQVQ4y2NgGBTgnoDEf3Iw9Qz4TyagngEMKrX/ycKDx4CBD8SBT0hDGwAA0mKUiJ0DYxAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TH.png
// module id = 1278
// module chunks = 0